export default __webpack_public_path__ + "static/media/isajl4p7dcqbvrvc8rtu.b83770e3.webp";